// extracted by mini-css-extract-plugin
export default {"visuallyhidden":"VisuallyHidden_visuallyhidden__Uvy58"};